/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface MovingTime
 */
export interface MovingTime {
  /**
   *
   * @type {string}
   * @memberof MovingTime
   */
  cubeId: string
  /**
   *
   * @type {number}
   * @memberof MovingTime
   */
  value: number
}

export function MovingTimeFromJSON(json: any): MovingTime {
  return MovingTimeFromJSONTyped(json, false)
}

export function MovingTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovingTime {
  if (json === undefined || json === null) {
    return json
  }
  return {
    cubeId: json['cubeId'],
    value: json['value'],
  }
}

export function MovingTimeToJSON(value?: MovingTime | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    cubeId: value.cubeId,
    value: value.value,
  }
}
